module.exports = {"name":"html5","type":"adapter","tech":"js","author":"Jordi Aguilar","version":"6.1.1","built":"2017-12-13","repo":"https://bitbucket.org/npaw/html5-adapter-js.git","libVersion":"6.1.7","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0